import { PureComponent } from "react";

class NoMatch extends PureComponent {
    render() {
        return <div>

        </div>
    }
}

export default NoMatch;